class HeaderController extends AbstractController
	@register()
	@inject '$scope',
		'$rootScope'
		'$state'
		'ConfigurationService'
		'MessageTerminal'
		'UserInformation'
		'CDN_URL'

	initialize: ->
		@homeState = @$state.href(@ConfigurationService.get('Backoffice.Home.DefaultState', true))
		@masterUser = @UserInformation.getMasterUser()
		@user = @UserInformation.getSubUser()

		customUserCssConfig = @ConfigurationService.get('Backoffice.Theme.CssFile', true)

		if customUserCssConfig
			@$rootScope.customUserCssHref = @CDN_URL + '/' + customUserCssConfig

		@MessageTerminal.publish @MessageTerminal.events.REFRESH
